import { addDoc, collection, limit, onSnapshot, orderBy, query } from 'shared/services/firebase';
import { ref } from 'vue';

export default function useHistory(db, user, subscriptionManager) {
  const entities = ref({});
  const loading = ref(true);

  const init = () => {
    loading.value = true;
    const q = query(collection(db, 'users', user.value.uid, 'history'), orderBy('createdAt', 'desc'), limit(20));
    const unsubscribe = onSnapshot(q, (querySnapshot) => {
      querySnapshot.forEach((doc) => {
        entities.value[doc.id] = doc.data();
      });
    });
    subscriptionManager.addSubscriber(unsubscribe, { auth: true });
    loading.value = false;
  };

  const addSingle = async (data) => {
    const colRef = collection(db, 'users', user.value.uid, 'history');
    const subdocRef = await addDoc(colRef, data);
    return subdocRef.id;
  };

  return {
    init,
    addSingle,
    entities,
  };
}
